import React from "react";

const WA_PHONE = "40756889809"; // 0756 889 809 → 40756889809 (RO country code)
const WA_MESSAGE = "Salut ANAIZA SHOP! Aș dori informații despre produsele voastre.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(WA_MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact WhatsApp ANAIZA SHOP"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 group"
      data-testid="whatsapp-float"
    >
      {/* pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" style={{ animationDuration: "2.4s" }} />
      {/* main bubble */}
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-xl shadow-[#25D366]/30 hover:scale-110 hover:bg-[#1ebe57] transition-all duration-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="30"
          height="30"
          fill="#FFFFFF"
          aria-hidden="true"
        >
          <path d="M16.001 3.2C9.039 3.2 3.394 8.845 3.394 15.807c0 2.226.587 4.397 1.704 6.31L3.2 28.8l6.86-1.857a12.6 12.6 0 0 0 5.94 1.49h.005c6.96 0 12.606-5.645 12.606-12.605 0-3.37-1.31-6.534-3.69-8.918A12.526 12.526 0 0 0 16 3.2zm0 22.866h-.004a10.473 10.473 0 0 1-5.336-1.46l-.382-.227-3.97 1.075 1.06-3.866-.249-.397a10.453 10.453 0 0 1-1.601-5.583c0-5.8 4.72-10.521 10.522-10.521 2.811 0 5.453 1.097 7.44 3.087a10.45 10.45 0 0 1 3.078 7.438c0 5.8-4.72 10.454-10.558 10.454zm5.737-7.83c-.314-.157-1.86-.918-2.149-1.023-.288-.105-.498-.157-.707.158-.21.314-.812 1.023-.996 1.232-.184.21-.367.236-.681.078-.314-.157-1.327-.49-2.527-1.56-.934-.832-1.564-1.86-1.748-2.175-.184-.314-.02-.484.138-.64.142-.142.314-.367.472-.55.157-.184.21-.314.314-.524.105-.21.053-.394-.026-.55-.078-.158-.707-1.705-.97-2.336-.255-.613-.515-.53-.707-.54l-.602-.011a1.155 1.155 0 0 0-.838.394c-.288.315-1.1 1.075-1.1 2.622 0 1.547 1.126 3.04 1.283 3.25.158.21 2.214 3.38 5.367 4.744.75.324 1.335.518 1.79.663.752.24 1.436.206 1.977.125.603-.09 1.86-.76 2.122-1.494.262-.735.262-1.366.184-1.494-.078-.13-.288-.21-.602-.367z"/>
        </svg>
      </span>
      {/* tooltip on hover (desktop only) */}
      <span className="hidden md:block absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-gray-900 text-white text-xs uppercase tracking-[0.2em] font-bold px-4 py-2.5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Scrie pe WhatsApp
      </span>
    </a>
  );
}
